import EmojiModal from '@/components/EmojiModal';
import { Icon } from '@shopify/polaris';
import { IconsIcon } from '@shopify/polaris-icons';
import { useState } from 'react';
interface IProps {
  disabled?: boolean;
  onFocus: () => void;
  onlyShowEmoji?: boolean;
}

const IconButton = ({ disabled, onFocus, onlyShowEmoji }: IProps) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [savedRange, setSavedRange] = useState<Range | null>(null);
  const handleChangeIsOpenModal = (value: boolean) => {
    setIsOpenModal(value);
  };
  const handleAddText = (text: string) => {
    if (savedRange) {
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(savedRange);
    }

    onFocus();
    document.execCommand('insertHTML', false, text);
  };

  const handleOpenModal = () => {
    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
      setSavedRange(selection.getRangeAt(0).cloneRange());
    }
    setIsOpenModal(true);
  };

  return (
    <div className="wrap-icon-btn">
      <button title="Emoji" className="fn-btn" onClick={handleOpenModal} disabled={disabled}>
        <Icon source={IconsIcon} tone="base" />
        <span style={{ fontSize: '12px', fontWeight: '500' }}>Icons</span>
      </button>
      <EmojiModal
        onClose={() => {
          handleChangeIsOpenModal(false);
        }}
        handleAddText={handleAddText}
        open={isOpenModal}
        onlyShowEmoji={onlyShowEmoji}
      />
    </div>
  );
};

export default IconButton;
